import { CircularProgress } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid-premium";
import React from "react";
import { DocDataGridSavingContext } from "../DocDataGridSavingContext.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
}

function SavingIndicatorCell({ rowId }: { rowId: string }) {
  const { isSavingRow } = React.useContext(DocDataGridSavingContext);
  if (!isSavingRow(rowId)) return null;
  return <CircularProgress size={16} />;
}

export function createSavingIndicatorColumn<T extends DocDataGrid_ItemFragment>(
  options: Options
): GridColDef<DocDataGridRow<T>> {
  return {
    field: "savingIndicator",
    headerName: options.headerName,
    width: 32,
    editable: false,
    sortable: false,
    filterable: false,
    renderHeader: () => null,
    renderCell: params => {
      if (params.row.kind === "input") return null;
      return <SavingIndicatorCell rowId={params.row.id} />;
    },
  };
}
